import { Box } from "@mui/material";
import {
  LICENSE_CODE_TO_DATA_MAP,
  getLicenseImage,
} from "Components/Licenses/licenseUtils";
import type { PartyLicenseDto } from "Infrastructure/Api/Api";

type Props = {
  license: PartyLicenseDto;
};

// Thumbnail of the license card artwork for dropdown options.
export const LicenseOptionImage = ({ license: { code, region } }: Props) => {
  const { title } = LICENSE_CODE_TO_DATA_MAP[code];

  return (
    <Box
      alt={title}
      component="img"
      src={getLicenseImage(code, region)}
      sx={{ height: 56, borderRadius: "6px", flexShrink: 0 }}
    />
  );
};
